import React from 'react';
import AnnotationPatientProfile from './AnnotationPatientProfile';
import AnnotationCaseAddictionalSection from './AnnotationCaseAddictionalSection';
import ObservationResults from './ObservationResults';
import { useDataAnnotation } from '../context/DataAnnotationProvider';
import Discrepency from './Discrepency';
import { PatientProfileProvider } from '../../../components/ProfileBar/hooks';
import { LoadingSpinner } from '../../../components/LoadingSpinner';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';

const AnnotationContent = () => {
  const { discrepency, loading, currentCase } = useDataAnnotation();
  const { resolvingSubmitCount } = useSelector(
    (state: RootState) => state.dataAnnotation,
  );
  if (!loading && !currentCase) {
    return (
      <div className="d-flex justify-content-center align-items-center h-100 w-100">
        <span className="roboto font-16">
          There are no more cases for you to review at this time. Check back
          again soon.
        </span>
      </div>
    );
  }
  return (
    <div className="annotation-content-container">
      {loading ? (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          <LoadingSpinner showText="Loading cases..." />
        </div>
      ) : (
        <>
          <PatientProfileProvider dataAnnotation>
            <AnnotationPatientProfile />
          </PatientProfileProvider>
          <div className="d-flex w-100">
            {/* Additional Section */}
            <div className="d-flex flex-column align-items-center w-50">
              {discrepency && resolvingSubmitCount > 0 && <Discrepency />}
              <AnnotationCaseAddictionalSection />
            </div>
            <ObservationResults />
          </div>
        </>
      )}
    </div>
  );
};

export default AnnotationContent;
